import React, { useEffect, useReducer, useRef, useState } from "react";
import useContextMenu from "contextmenu";
import "./NewContextMenu.css";
import "./Tooth.css";

function Tooth({
  number,
  positionX,
  positionY,
  onChange,
  toothData,
  actionHandler,
  toothNumberHandler,
  newService,
  keywords,
}) {
  const initialState = {
    center: {
      state: 0,
      treatment: "",
      treatmentId: 0,
    },
    top: {
      state: 0,
      treatment: "",
      treatmentId: 0,
    },
    bottom: {
      state: 0,
      treatment: "",
      treatmentId: 0,
    },
    left: {
      state: 0,
      treatment: "",
      treatmentId: 0,
    },
    right: {
      state: 0,
      treatment: "",
      treatmentId: 0,
    },
  };
  const [initialData, setInitialData] = useState(toothData);
  const [toothState, dispatch] = useReducer(reducer, initialData);
  const [toothStateText, setToothStateText] = useState(null);

  useEffect(() => {
    if (toothData) {
      setInitialData(toothData);
    }
  }, [toothData]);

  function reducer(toothState, action) {
    switch (action.type) {
      case "Nuevo Servicio":
        let partialTooth = toothState[action.zone];
        if (partialTooth?.state !== undefined) {
          partialTooth.state = action?.value;
          partialTooth.treatment = newService.state;
          toothState[action.zone] = partialTooth;
          return { ...toothState };
        } else {
          debugger;
          partialTooth = initialState[action.zone];
          partialTooth.state = action?.value;
          partialTooth.treatment = newService.state;
          toothState[action.zone] = partialTooth;
          return { ...initialState };
        }

      case "clear":
        toothState[action.zone] = initialState.center;
        return { ...toothState };
      default:
        let tooth = toothState[action.zone];
        tooth = initialState[action.zone];
        tooth.state = action?.value;
        tooth.treatment = newService.state;
        toothState[action.zone] = tooth;
        return { ...initialState };
    }
  }

  const clear = (action) => ({ type: "clear", zone: action });

  const firstUpdate = useRef(true);
  useEffect(() => {
    if (firstUpdate.current) {
      firstUpdate.current = false;
      return;
    }
    onChange(number, toothState);
  }, [toothState, onChange, number]);

  // Done SubMenu
  const doneSubMenu = (place, value) => {
    let allKeywords = ["Nuevo Servicio", ...keywords];
    return allKeywords.reduce((acc, e) => {
      // console.log({ type: e, value: value, zone: place });
      acc[e] = () => {
        dispatch({ type: e, value: value, zone: place });
      };
      return acc;
    }, {});
  };

  // Todo SubMenu
  const todoSubMenu = (place, value) => {
    let allKeywords = ["Nuevo Servicio", ...keywords];
    return allKeywords.reduce((acc, e) => {
      // console.log({ type: e, value: value, zone: place });
      acc[e] = () => {
        dispatch({ type: e, value: value, zone: place });
      };
      return acc;
    }, {});
  };
  // Main ContextMenu
  const menuConfig = (place) => {
    if (newService.setter) {
      newService.setter(null);
      newService.selectedSubActionSetter(null);
    }
    return {
      "Completado 🟢": doneSubMenu(place, 1),
      "Pendiente 🔴": todoSubMenu(place, 2),
      "Limpiar ⚪": () => {
        dispatch(clear(place, 0));
      },
    };
  };

  let getClassNamesByZone = (zone) => {
    if (toothState[zone]?.state === 1) {
      return "done";
    } else if (toothState[zone]?.state === 2) {
      return "to-do";
    }
    return "";
  };

  // Tooth position
  const translate = `translate(${positionX},${positionY})`;

  const onToothClick = (e) => {
    actionHandler(e);
    toothNumberHandler(number);
  };

  return (
    <svg className="tooth">
      <g transform={translate}>
        <polygon
          points="0,0 20,0 15,5 5,5"
          onClick={() => onToothClick(menuConfig("top"))}
          className={getClassNamesByZone("top")}
          onMouseOver={() => setToothStateText(toothState?.top)}
          onMouseLeave={() => setToothStateText(null)}
        ></polygon>
        <polygon
          points="5,15 15,15 20,20 0,20"
          onClick={() => onToothClick(menuConfig("bottom"))}
          className={getClassNamesByZone("bottom")}
          onMouseOver={() => setToothStateText(toothState?.bottom)}
          onMouseLeave={() => setToothStateText(null)}
        />
        <polygon
          points="15,5 20,0 20,20 15,15"
          onClick={() => onToothClick(menuConfig("left"))}
          className={getClassNamesByZone("left")}
          onMouseOver={() => setToothStateText(toothState?.left)}
          onMouseLeave={() => setToothStateText(null)}
        />
        <polygon
          points="0,0 5,5 5,15 0,20"
          onClick={() => onToothClick(menuConfig("right"))}
          className={getClassNamesByZone("right")}
          onMouseOver={() => setToothStateText(toothState?.right)}
          onMouseLeave={() => setToothStateText(null)}
        />
        <polygon
          points="5,5 15,5 15,15 5,15"
          onClick={() => onToothClick(menuConfig("center"))}
          className={getClassNamesByZone("center")}
          onMouseOver={() => setToothStateText(toothState?.center)}
          onMouseLeave={() => setToothStateText(null)}
        />
        {/* {drawToothActions()} */}

        <text
          x="6"
          y="30"
          stroke="navy"
          fill="navy"
          strokeWidth="0.1"
          className="tooth"
        >
          {number}
        </text>
        {toothStateText !== null && (
          <text
            x="0"
            y="40"
            stroke="navy"
            fill="navy"
            strokeWidth="0.2"
            className="tooth"
          >
            {toothStateText?.treatment}
          </text>
        )}
      </g>
    </svg>
  );
}

export default Tooth;
